const documentTypeServiceName = "/DocumentType";

export function documentTypeDetailService (http) {
    return {
        uploadDocumentAsync: async (fileInformation) => {         
            return (await http.post(documentTypeServiceName + '/UploadDocumentAsync', fileInformation));
        },
        uploadDocumentsAsync: async (filesInformation) => { 
            return (await http.post(documentTypeServiceName + '/UploadDocumentsAsync', filesInformation));
        },        
        getLatestDocumentTypesAsync: async (documentTypeId) => {
            return http.get(`${documentTypeServiceName}/GetLatestDocumentTypesAsync?documentTypeId=${documentTypeId}`);
        },
        getAllDocumentTypesAsync: async (documentTypeId) => {
            return http.get(`${documentTypeServiceName}/GetAllCertificatesTypesAsync?documentTypeId=${documentTypeId}`);
        },
        getAllDocumentTypeDetailsAsync: async () => {
            return await http.get(documentTypeServiceName + '/GetAllDocumentTypeDetailsAsync');
        },
        deleteExistingDocumentTypeDetailsAsync: async (id) => {
            return http.get(`${documentTypeServiceName}/DeleteDocumentTypeDetailsAsync?id=${id}`);
        },
        uploadExistingImageTypeDocumentsAsync: async (iDs, documentTypeId) => { 
            let params = {
                ids: iDs,
                DocumentTypeId: documentTypeId
            }
            return (await http.post(documentTypeServiceName + '/UploadExistingImageTypeDocumentsAsync', params));
        },        
        
    }
}